import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categories } from '@/mocks/categories';
import { sites } from '@/mocks/sites';
import useScrollToTop from '@/hooks/useScrollToTop';

export default function CategoryPage() {
  useScrollToTop();
  const { slug } = useParams<{ slug: string }>();

  const currentCategory = categories.find((c) => c.slug === slug) || categories[0];
  const categorySites = sites.filter((s) => s.categorySlug === (slug || 'life'));

  if (!slug) {
    return null;
  }

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: `${currentCategory.name} - 91网址导航`,
            url: `https://www.91wangzhi.com/category/${currentCategory.slug}`,
            description: currentCategory.description,
            isPartOf: {
              '@type': 'WebSite',
              name: '91网址',
              url: 'https://www.91wangzhi.com/',
            },
          }),
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 pb-14">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="mb-6">
                <Breadcrumb
                  items={[
                    { label: '首页', to: '/' },
                    { label: '分类导航', to: '/category/life' },
                    { label: currentCategory.name },
                  ]}
                />
              </div>

              <div className="mb-10">
                <div className="flex items-center gap-4 mb-3">
                  <span className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-lg">
                    <i className={`${currentCategory.icon} text-xl text-primary-500`}></i>
                  </span>
                  <div>
                    <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                      {currentCategory.name}
                    </h1>
                    <p className="text-sm text-foreground-500 mt-1">{currentCategory.description}</p>
                  </div>
                </div>
              </div>

              <div className="mb-8">
                <div className="flex flex-wrap gap-2">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className={`whitespace-nowrap cursor-pointer px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
                        cat.slug === currentCategory.slug
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-500 border border-background-200/70'
                      }`}
                    >
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>

              {categorySites.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                  {categorySites.map((site) => (
                    <a
                      key={site.id}
                      href={site.url}
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      className="group bg-background-100 rounded-lg p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                    >
                      <div className="flex items-start justify-between mb-3">
                        <span className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                          <span className="text-primary-600 font-bold text-sm font-heading">
                            {site.name.charAt(0)}
                          </span>
                        </span>
                        <div className="flex items-center gap-1">
                          <span className="w-4 h-4 flex items-center justify-center">
                            <i className="ri-star-fill text-xs text-secondary-500"></i>
                          </span>
                          <span className="text-xs text-foreground-500">{site.rating}</span>
                        </div>
                      </div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-2 font-heading whitespace-nowrap">
                        {site.name}
                      </h3>
                      <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                        {site.description}
                      </p>
                      <div className="flex flex-wrap items-center gap-2">
                        {site.tags.slice(0, 3).map((tag) => (
                          <span
                            key={tag}
                            className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                    </a>
                  ))}
                </div>
              ) : (
                <div className="text-center py-20">
                  <span className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-background-100 rounded-full">
                    <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                  </span>
                  <p className="text-foreground-500">该分类暂无收录网站，敬请期待</p>
                </div>
              )}
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}